// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Leaflet from "leaflet";
import * as Js_option from "../../../../../../../../../../node_modules/rescript/lib/es6/js_option.js";
import * as MapConfig from "../../utils/MapConfig.bs.js";
import * as OrderDashboardAssetsManager from "../../../../../assets/OrderDashboardAssetsManager.bs.js";

var pickup_icon = OrderDashboardAssetsManager.getImage("pickup_icon.svg");

var drop_icon = OrderDashboardAssetsManager.getImage("drop_icon.svg");

var accepted_trip_icon = OrderDashboardAssetsManager.getImage("accept-trip-icon.svg");

var start_trip_icon = OrderDashboardAssetsManager.getImage("start-trip-icon.svg");

var end_trip_icon = OrderDashboardAssetsManager.getImage("end-trip-icon.svg");

var cancelled_icon = OrderDashboardAssetsManager.getImage("cancelled_icon.svg");

var dummy_waypoint_icon1 = OrderDashboardAssetsManager.getImage("waypoint_1_icon.svg");

var dummy_waypoint_icon2 = OrderDashboardAssetsManager.getImage("waypoint_2_icon.svg");

var dummy_waypoint_icon3 = OrderDashboardAssetsManager.getImage("waypoint_3_icon.svg");

function getLeafletIcon(markerData, markerOrientation) {
  var title = markerData.tooltip.title;
  var tmp;
  if (title !== undefined) {
    switch (title) {
      case "Cancelled" :
          tmp = cancelled_icon;
          break;
      case "Drop Location" :
          tmp = drop_icon;
          break;
      case "Pickup Location" :
          tmp = pickup_icon;
          break;
      case "Trip Accepted" :
          tmp = accepted_trip_icon;
          break;
      case "Trip Ended" :
          tmp = end_trip_icon;
          break;
      case "Trip Started" :
          tmp = start_trip_icon;
          break;
      default:
        tmp = pickup_icon;
    }
  } else {
    tmp = pickup_icon;
  }
  var tmp$1;
  switch (markerOrientation) {
    case /* Left */0 :
        tmp$1 = Js_option.some([
              -20,
              -41
            ]);
        break;
    case /* Right */1 :
        tmp$1 = Js_option.some([
              20,
              -41
            ]);
        break;
    case /* Straight */2 :
        tmp$1 = Js_option.some([
              1,
              -34
            ]);
        break;
    
  }
  return {
          iconUrl: tmp,
          iconSize: Js_option.some([
                25,
                41
              ]),
          iconAnchor: Js_option.some([
                12,
                41
              ]),
          popupAnchor: tmp$1,
          shadowUrl: Js_option.some(""),
          shadowSize: Js_option.some([
                41,
                41
              ]),
          shadowAnchor: Js_option.some([
                12,
                41
              ])
        };
}

function getVehicleIcon(vehicleType) {
  var tmp;
  switch (vehicleType) {
    case /* TWO_WHEELER */0 :
        tmp = MapConfig.two_wheeler_icon;
        break;
    case /* THREE_WHEELER */1 :
        tmp = MapConfig.three_wheeler_icon;
        break;
    case /* FOUR_WHEELER */2 :
        tmp = MapConfig.four_wheeler_icon;
        break;
    
  }
  return {
          iconUrl: tmp,
          iconSize: Js_option.some([
                25,
                41
              ]),
          iconAnchor: Js_option.some([
                12,
                41
              ]),
          popupAnchor: Js_option.some([
                1,
                -34
              ]),
          shadowUrl: Js_option.some(""),
          shadowSize: Js_option.some([
                41,
                41
              ]),
          shadowAnchor: Js_option.some([
                12,
                41
              ])
        };
}

var waypointIcon1_iconSize = Js_option.some([
      25,
      41
    ]);

var waypointIcon1_iconAnchor = Js_option.some([
      12,
      41
    ]);

var waypointIcon1_popupAnchor = Js_option.some([
      1,
      -34
    ]);

var waypointIcon1_shadowUrl = Js_option.some("");

var waypointIcon1_shadowSize = Js_option.some([
      41,
      41
    ]);

var waypointIcon1_shadowAnchor = Js_option.some([
      12,
      41
    ]);

var waypointIcon1 = {
  iconUrl: dummy_waypoint_icon1,
  iconSize: waypointIcon1_iconSize,
  iconAnchor: waypointIcon1_iconAnchor,
  popupAnchor: waypointIcon1_popupAnchor,
  shadowUrl: waypointIcon1_shadowUrl,
  shadowSize: waypointIcon1_shadowSize,
  shadowAnchor: waypointIcon1_shadowAnchor
};

var waypointLocationIcon1 = Leaflet.icon(waypointIcon1);

var waypointIcon2_iconSize = Js_option.some([
      25,
      41
    ]);

var waypointIcon2_iconAnchor = Js_option.some([
      12,
      41
    ]);

var waypointIcon2_popupAnchor = Js_option.some([
      1,
      -34
    ]);

var waypointIcon2_shadowUrl = Js_option.some("");

var waypointIcon2_shadowSize = Js_option.some([
      41,
      41
    ]);

var waypointIcon2_shadowAnchor = Js_option.some([
      12,
      41
    ]);

var waypointIcon2 = {
  iconUrl: dummy_waypoint_icon2,
  iconSize: waypointIcon2_iconSize,
  iconAnchor: waypointIcon2_iconAnchor,
  popupAnchor: waypointIcon2_popupAnchor,
  shadowUrl: waypointIcon2_shadowUrl,
  shadowSize: waypointIcon2_shadowSize,
  shadowAnchor: waypointIcon2_shadowAnchor
};

var waypointLocationIcon2 = Leaflet.icon(waypointIcon2);

var waypointIcon3_iconSize = Js_option.some([
      25,
      41
    ]);

var waypointIcon3_iconAnchor = Js_option.some([
      12,
      41
    ]);

var waypointIcon3_popupAnchor = Js_option.some([
      1,
      -34
    ]);

var waypointIcon3_shadowUrl = Js_option.some("");

var waypointIcon3_shadowSize = Js_option.some([
      41,
      41
    ]);

var waypointIcon3_shadowAnchor = Js_option.some([
      12,
      41
    ]);

var waypointIcon3 = {
  iconUrl: dummy_waypoint_icon3,
  iconSize: waypointIcon3_iconSize,
  iconAnchor: waypointIcon3_iconAnchor,
  popupAnchor: waypointIcon3_popupAnchor,
  shadowUrl: waypointIcon3_shadowUrl,
  shadowSize: waypointIcon3_shadowSize,
  shadowAnchor: waypointIcon3_shadowAnchor
};

var waypointLocationIcon3 = Leaflet.icon(waypointIcon3);

export {
  pickup_icon ,
  drop_icon ,
  accepted_trip_icon ,
  start_trip_icon ,
  end_trip_icon ,
  cancelled_icon ,
  dummy_waypoint_icon1 ,
  dummy_waypoint_icon2 ,
  dummy_waypoint_icon3 ,
  getLeafletIcon ,
  getVehicleIcon ,
  waypointIcon1 ,
  waypointLocationIcon1 ,
  waypointIcon2 ,
  waypointLocationIcon2 ,
  waypointIcon3 ,
  waypointLocationIcon3 ,
  
}
/* pickup_icon Not a pure module */
